import { DOCUMENT_FORMATS } from './documentFormats.js';
import { DocumentGlyph } from './DocumentGlyph';
import './DocumentSkeleton.css';

/**
 * Document en préparation (`artifact_pending`, kind « document ») : silhouette de la
 * carte avec badge du format dès qu'il est annoncé. Reflet coupé en mouvement réduit.
 */
export function DocumentSkeleton({ format = null, title = null, label = null }) {
  const info = DOCUMENT_FORMATS[format] ?? null;
  return (
    <div className="doc-card doc-card--pending" role="status" aria-live="polite">
      <DocumentGlyph format={format} />
      <div className="doc-card__main">
        <span className="doc-card__eyebrow">{info ? info.long : 'Document'}</span>
        {title
          ? <p className="doc-card__title">{title}</p>
          : <span className="doc-skel__line is-title" aria-hidden="true" />}
        <span className="doc-card__pending">{label ?? 'Génération du document…'}</span>
        <span className="doc-skel__line" aria-hidden="true" />
      </div>
    </div>
  );
}
